"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _printableWorksheets = require("printableWorksheets");
var _state = require("printableWorksheets/state");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _wsHeader = _interopRequireDefault(require("./wsHeader"));
var _wsList = _interopRequireDefault(require("./wsList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var WorksheetsView = function WorksheetsView() {
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    defaultSearch = _usePrintableWorkshee.defaultSearch,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    activeGrade = _usePrintableWorkshee.activeGrade;
  var isTeacherEnvironment = worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-view",
    "data-sentry-component": "WorksheetsView",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-view__header"
  }, /*#__PURE__*/_react["default"].createElement(_wsHeader["default"], {
    hideSearch: isTeacherEnvironment,
    "data-sentry-element": "WSHeader",
    "data-sentry-source-file": "index.tsx"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-view__list".concat(!defaultSearch ? ' un-focus' : '')
  }, /*#__PURE__*/_react["default"].createElement(_wsList["default"], {
    "data-sentry-element": "WSList",
    "data-sentry-source-file": "index.tsx"
  })));
};
var _default = WorksheetsView;
exports["default"] = _default;